<template>
  <div class="flowEditBody">
    <div class="body">
      <div class="bodyLeft">
        <div class="Steps">
          <template v-if="showFlowImage === null">
            <p style="font-size: 16px; color: #000; margin-top: 36px">
              流程图暂无
            </p>
          </template>
          <template v-else>
            <img :src="flowImage" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import flowService from "@/CommonDP/service/flow-service";
import { getFlowImage } from "@/CommonDP/utils";

// 已废弃：请使用 flowImage 组件替换它
export default {
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      flowImage: "",
      showFlowImage: ""
    };
  },
  methods: {
    showView(flowDefinitionId) {
      this.getFlow(flowDefinitionId);
    },
    // 获取流程
    async getFlow(flowDefinitionId) {
      const res = await flowService.getFlow(flowDefinitionId, 0);
      this.showFlowImage = res.data.flowImage;
      this.flowImage = getFlowImage(res.data.flowImage.slice(7));
    }
  }
};
</script>
<style lang="scss" scoped>
.flowEditBody {
  width: 100%;
  height: 100%;
}
.body {
  display: flex;
  justify-content: flex-start;
  height: 100%;
  .bodyLeft {
    width: 100%;
    height: 100%;
    .oper {
      width: 100%;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      padding-right: 20px;
      box-sizing: border-box;
      border-bottom: 1px solid #e5e8f1;
    }
    .Steps {
      width: 100%;
      height: calc(100% - 40px);
    }
  }
  .bodyRight {
    width: 30%;
    border-left: 2px solid #e4e7ed;
    // height: 100%;
  }
}
</style>
